import MentoringDummyIcon from './MentoringDummyIcon.vue';

export default MentoringDummyIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/dummy/index.ts